import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class XorExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        return (left || right) && !(left && right);
    }
}
//# sourceMappingURL=XorExpression.js.map